/* unplugin-vue-components disabled */import script from "./company-welfare.vue?vue&type=script&setup=true&lang=ts"
export * from "./company-welfare.vue?vue&type=script&setup=true&lang=ts"

import "./company-welfare.vue?vue&type=style&index=0&id=e683da46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e683da46"]])

export default __exports__